import { render, staticRenderFns } from "./ViewMethodPicot.vue?vue&type=template&id=bc107b70&scoped=true"
import script from "./ViewMethodPicot.vue?vue&type=script&lang=js"
export * from "./ViewMethodPicot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc107b70",
  null
  
)

export default component.exports